//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import Regiao from './Regiao';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'RegiaoForm',
  data() {
    return {
      regiao: new Regiao(),
      regiaoResources: this.$api.regiao(this.$resource),
      disableButton: false,
      layoutClass: { wrap: true },
      dialog: {
        content: '',
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  computed: {
    ...generateComputed('Regiao', [
      'canAccessCRUD',
    ]),
  },
  components: {
    Confirm,
  },
  methods: {
    cancel() {
      this.limparFormulario();
    },
    editar(regiao) {
      this.regiao = new Regiao({ ...regiao });
    },
    limparFormulario() {
      this.regiao = new Regiao();
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save() {
      const objArmazenamento = {
        ...this.regiao,
      };

      let salvarOuAtualizar;
      let inclusao = true;
      if (this.regiao.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.regiaoResources.atualizar(objArmazenamento);
      } else {
        salvarOuAtualizar = this.regiaoResources.gravar(objArmazenamento);
      }

      salvarOuAtualizar.then(() => this.limparFormulario())
        .then(() => this.$toast.create(this.$t((inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'))
          , 'snack', 3E3))
        .then(() => {
          this.$emit('FORMULARIO_CADASTRO_REGIAO_SALVAR', Object.assign({ }, this.regiao));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/regiao/RegiaoForm.vue?vue&type=script&lang=js&